<bepatient-question-title-v3
  *ngIf="question.title"
  [title]="question.title"
  [constraints]="question.constraints"
  [color]="color"
  [errors]="question.errors"
  [key]="question.key"
  [value]="value"
  [hasCondition]="question.hasCondition"
>
</bepatient-question-title-v3>

<p *ngIf="question.text">{{ question.text }}</p>
